import { render, staticRenderFns } from "./CostoCIF.vue?vue&type=template&id=0d4aa49c"
import script from "./CostoCIF.vue?vue&type=script&lang=js"
export * from "./CostoCIF.vue?vue&type=script&lang=js"
import style0 from "./CostoCIF.vue?vue&type=style&index=0&id=0d4aa49c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports